import React from 'react';
import { FormTab, TextInput, ReferenceInput, AutocompleteInput } from 'react-admin';

import Create from '../common/views/Create';
import TabbedForm from '../common/forms/TabbedForm';
import CountryInput from '../common/inputs/CountryInput';

const optionText = choice => choice.name ? choice.name : '';


const AddressCreate = props => (
	<Create {...props}>
		<TabbedForm redirect="list">
			<FormTab label="summary">
				<ReferenceInput label="Customer" source="customer_id" reference="customers" sort={{ field: 'name', order: 'ASC' }} allowEmpty>
					<AutocompleteInput optionText={optionText} />
				</ReferenceInput>
				<TextInput source="name" />
				<TextInput source="street" />
				<TextInput source="street_bis" />
				<TextInput source="number" />
				<TextInput source="box" />
				<TextInput source="zipcode" />
				<TextInput source="city" />
				<CountryInput source="country" />
				<TextInput source="vat_number" />
				<TextInput source="email" />
				<TextInput source="phone" />
			</FormTab>
		</TabbedForm>
	</Create>
);

export default AddressCreate;